"use client";

import React from "react";

const PatientSatisfaction: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Our Commitment to Patient Satisfaction
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        At Smile4Me, we believe that every patient deserves personalized attention and exceptional care. Our dedicated team of dental professionals is committed to providing a welcoming, comfortable environment where you can feel at ease discussing your oral health concerns. We take the time to listen to your needs and develop customized treatment plans tailored to your unique situation.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        In addition to our commitment to patient-centered care, we also provide educational resources to help you make informed decisions about your dental health. Our website features a wealth of information on various dental topics, as well as testimonials from satisfied patients who have experienced the difference that personalized care can make.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        We understand that finding the right dentist is an important decision, and we&apos;re here to support you every step of the way. Whether you&#39;re seeking relief from bruxism or require other dental services, our team at Smile4Me is dedicated to helping you achieve a healthy, confident smile that lasts a lifetime.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Don&#39;t let nocturnal teeth grinding control your life any longer. Take the first step towards protecting your oral health and contact us today to learn more about custom night guards and how they can help you overcome bruxism. Our friendly team is always here to answer your questions and schedule an appointment at a time that&#39;s convenient for you.
      </p>
    </div>
  );
};

export default PatientSatisfaction;